<template>
  <div class="ownerEvaluationLists vheight">
    <div class="score-kind ub-f1">
      <div class="kind-title ub ub-pc ub-ac" >
        {{EaAreaName}}在{{Year}}年{{Month}}月所管小区的评价情况
        <!-- <span class="mark-front">前10名</span>的物管企业 -->
      </div>
    <div class="container" :style="{height:'calc(100% - 55px - '+headerHeight+'px )'}">
      <div class="container-header"></div>
      <div class="grid">
        <el-table
          v-loading="loading"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;"
          height="100%"
          stripe
          border
          v-bind:index="indexMethod"
          :highlight-current-row="true"
        >
          <el-table-column
            label="序号"
            width="80"
            type="index"
            v-bind:index="indexMethod"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="EaHouseName"
            label="房屋"
            min-width="200"
            show-overflow-tooltip
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="TotalScore"
            label="评价得分"
            min-width="60"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">{{scope.row.TotalScore.toFixed(2)}}</template>
          </el-table-column>
        </el-table>
            </div>
       </div>
      </div>

    <div class="footer">
      <div class="fun">
        <!-- <span @click="tablechoose(true)">全选</span>

        <span @click="tablechoose(false)">反选</span>
        <span class="delete">删除</span>-->
      </div>
      <div class="page">
        <ps-page :page="pages" @getData="getData()"></ps-page>
      </div>
    </div>
  </div>
</template>

<script>
import { OpenControllerSvr }  from '@/service/OpenControllerSvr/OpenControllerSvr';
import { EvaluteResultController } from '@/service/EvaluteResultController/EvaluteResultController';
import { Page } from '@/models/page';
import { mapState } from 'vuex';
import { EaAreaControllerSvr } from '@/service/EaAreaControllerSvr.js';
import { AuthenticationControllerSvr } from '@/service/AuthenticationControllerSvr.js';
import { CommonControllerSvr } from '@/service/CommonControllerSvr/CommonControllerSvr';
import { division } from '@/assets/js/division';
import { EvaluateRankResultQueryPara } from '@/service/EvaluteResultController/EvaluateRankResultQueryPara.js';
import { headerredraw } from '@/mixin/headerredraw';
import { identityEnum } from '@/enum/identityEnum';

export default {
  components: {},
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      value: [],
      options: [],
      Sightlength: '',
      cantonCode: '',
      streetOfficeOrgCode: '',
      residentsCommitteeOrgCode: '',
      month: '',
      loading: false,
      tableData: [],
      identityEnum: new identityEnum(),
      evaluteResultController: new EvaluteResultController(),
      evaluateRankResultQueryPara: new EvaluateRankResultQueryPara(),
      pages: new Page(),
      showConton: false,
      evaluateObjType: 1,
      OrgName:this.$route.query.OrgName,
      Year:this.$route.query.Year,
      Month:this.$route.query.Month,
      EaAreaName:''
    };
  },
  computed: {
    ...mapState(['token', 'userInfo'])
  },
  created() {
    this.openControllerSvr = new OpenControllerSvr();
    this.CommonControllerSvr = new CommonControllerSvr();
  },
  mounted() {
    this.getData();
  },
  methods: {
    indexMethod(index) {
      return index + 1 + (this.pages.currentPage - 1) * this.pages.currtNum;
    }, 
    handleChange(value) {
      //this.Sightlength为3代表权限等级到区2街道1居委会
      if (this.Sightlength === 3) {
        this.cantonCode = value[0];
        this.streetOfficeOrgCode = value[1] || '';
        this.residentsCommitteeOrgCode = value[2] || '';
        if (this.residentsCommitteeOrgCode) {
          this.cantonCode = '';
          this.streetOfficeOrgCode = '';
        } else if (this.streetOfficeOrgCode) {
          this.cantonCode = '';
        }
      } else if (this.Sightlength === 2) {
        this.cantonCode = '';
        this.streetOfficeOrgCode = value[0] || '';
        this.residentsCommitteeOrgCode = value[1] || '';
        if (this.residentsCommitteeOrgCode) {
          this.streetOfficeOrgCode = '';
        }
      } else if (this.Sightlength === 1) {
        this.cantonCode = '';
        this.streetOfficeOrgCode = '';
        this.residentsCommitteeOrgCode = value[0] || '';
      }
    },
    getData() {
      if(this.$route.query.EvaluateObjType){
        this.evaluateObjType =this.$route.query.EvaluateObjType;
      }
      this.loading = true;
      this.evaluteResultController
        .GetEvaluateRecordList(
          this.$route.query.EaAeraCode,
          4,
          this.$route.query.Year,
          this.$route.query.Month,
          this.evaluateObjType,
          false,
          (this.pages.currentPage - 1) * this.pages.currtNum,
          this.pages.currtNum
        )
        .then(res => {
          this.EaAreaName =res._Items[0].EaAreaName;
          this.tableData = res._Items;
          this.pages.getCurrtNum = res.TotalCount;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" >
.ownerEvaluationLists {
  .el-table--border{
    min-height: 650px
  }
  .container{
    width: 50%;
  }
  .administration {
    .el-cascader {
      .el-input {
        width: 400px !important;
        .el-input__inner {
          width: 400px !important;
        }
      }
    }
  }
  .evaluateObjType {
    .el-select {
      width: 100px !important;
      .el-input {
        width: 100px !important;
      }
    }
  }
  .Datetime {
    .el-input {
      width: 120px !important;
      .el-input__suffix-inner {
        display: none;
      }
    }
  }
}

.el-cascader-menu {
  width: auto;
  .el-cascader-menu__item {
    padding: 8px 40px 8px 20px;
  }
}
.el-cascader-menu__item--extensible:after {
  font-family: element-icons;
  content: "\E604";
  font-size: 14px;
  color: #bfcbd9;
  position: absolute;
  right: 10px;
}
</style>
<style lang="scss" scoped>
.ownerEvaluationLists {
  // padding: 10px 0;
  width: 100%;
  height: 100%;
  // overflow-y: auto;
   .footer {
    width: 100%;
  }
  .incre {
    transform: rotate(90deg);
    color: #7cc562;
  }
  .decre {
    transform: rotate(-90deg);
    color: #ff4546;
  }
  .equal {
    color: #ffb11a;
  }
  .title {
    padding: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  // .score-kind {
  //   padding: 10px 20px;
  //   // width: 500px;
  // }
  .score-kind-chart {
    // height: 400px;
    padding: 10px 20px;
    align-self: stretch;
    .chart {
      height: 400px;
    }
  }
  .rank-container {
    padding: 20px 10px;
    height: calc(100% - 49px);
    overflow-y: auto;
  }
  .rank-kind {
    border: 1px solid #e2e2e2;
    border-top: none;
    padding: 10px 0 0;
    &:nth-child(1) {
      border-top: 1px solid #e2e2e2;
    }
  }
  .incre {
    transform: rotate(90deg);
    color: #7cc562;
  }
  .decre {
    transform: rotate(-90deg);
    color: #ff4546;
  }
  .equal {
    color: #ffb11a;
  }
  .mark-front {
    color: #409eff;
  }
  .mark-end {
    color: #ff494a;
  }
  .score-header {
    height: 66px;
    font-size: 20px;
    font-weight: bold;
    background-color: #ecf5ff;
    border: 1px solid #e2e2e2;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
  }
  .score-container {
    // flex-wrap: nowrap;
    position: relative;
    overflow-x: hidden;
    padding: 0;
    .rank-title {
      padding: 10px;
      font-size: 16px;
      font-weight: bold;
    }
  }
  .score-kind {
    // padding: 0 20px;
    border: 1px solid #e2e2e2;
    border-bottom: none;
    &:nth-child(1) {
      border-left: none;
    }
    &:nth-child(3) {
      border-right: none;
    }
    &:nth-child(2) {
      margin: 0 10px;
    }
    .kind-title {
      // font-weight: bold;
      width: 50%;
      font-size: 16px;
      height: 50px;
      background-color: #f7f8fa;
      border-bottom: 1px solid #e2e2e2;
    }
    .kind-content {
      padding: 20px 10px;
      height: calc(100% - 50px);
    }
  }
}
</style>